import { useToast } from '@/shared/hooks/useToast'
import { Icon } from '@/shared/ui/Icon'

export function Toasts() {
  const items = useToast((s) => s.items)
  if (items.length === 0) return null
  return (
    <div className="toasts" aria-live="polite">
      {items.map((t) => (
        <div key={t.id} className="toast">
          <Icon
            name={t.tone === 'bad' ? 'warn' : 'check'}
            style={t.tone === 'bad' ? { color: 'var(--bad)' } : undefined}
          />
          <span>{t.message}</span>
        </div>
      ))}
    </div>
  )
}
